module.exports = __webpack_public_path__ + "static/media/jala-logo.2878493c.png";